var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46447 6.285C4.85499 6.67553 4.85499 7.30869 4.46447 7.69922L0.585787 11.5779C0.195262 11.9684 0.195262 12.6016 0.585786 12.9921C0.976311 13.3826 1.60948 13.3826 2 12.9921L7.29289 7.69922C7.68342 7.30869 7.68342 6.67553 7.29289 6.28501L2 0.992111C1.60948 0.601587 0.976311 0.601588 0.585787 0.992112C0.195262 1.38264 0.195262 2.0158 0.585786 2.40633L4.46447 6.285Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46447 6.285C4.85499 6.67553 4.85499 7.30869 4.46447 7.69922L0.585787 11.5779C0.195262 11.9684 0.195262 12.6016 0.585786 12.9921C0.976311 13.3826 1.60948 13.3826 2 12.9921L7.29289 7.69922C7.68342 7.30869 7.68342 6.67553 7.29289 6.28501L2 0.992111C1.60948 0.601587 0.976311 0.601588 0.585787 0.992112C0.195262 1.38264 0.195262 2.0158 0.585786 2.40633L4.46447 6.285Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.6cca9fd3bd3efcb00468e505965847f1.svg";
export { ForwardRef as ReactComponent };